import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'informed';
import { InputTypeText } from '../elements';

const TableFilterForm = ({ title, children, onFilterChange, defaultFilterFields }) => {
  const [isFilterShowing, setFilterShowing] = useState(false);
  return (
    <div>
      <div className="d-flex align-items-center position-relative">
        <h2 style={{ fontSize: '1.35rem' }}>{title}</h2>
        <button type="button" onClick={() => setFilterShowing(!isFilterShowing)} className="btn-invisible table-filters">Mais filtros {isFilterShowing ? '▲' : '▼'}</button>
      </div>
      <Form
        onValueChange={filters => onFilterChange(filters)}
      >
        <div className="row">
        {defaultFilterFields.map((field) => (
          <InputTypeText
            key={field.name}
            field={field.name}
            label={field.label}
            col={(field.col && field.col.toString()) || "6"}
          />
          )
        )}
        </div>
        <div className="row">
          {isFilterShowing && children}
        </div>
      </Form>
    </div>
  );
};

TableFilterForm.propTypes = {
  children: PropTypes.node,
  onFilterChange: PropTypes.func,
  title: PropTypes.string,
  defaultFilterFields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    col: PropTypes.number,
  }))
};

TableFilterForm.defaultProps = {
  children: null,
  onFilterChange: () => {},
  title: 'Aprovação - Financeira',
  defaultFilterFields: [
    {
      name: 'real_name',
      label: 'Nome'
    },
    {
      name: 'cpf',
      label: 'CPF'
    },
  ]
};

export default TableFilterForm;
